<template>
    <b-modal
        size="xl"
        v-model="modalShow"
        title="グループ所属履歴"
        ok-only
        ok-title="閉じる"
        ok-variant="yokumiru-gray">
        <div class="modal-body t-admin">
            <div v-if="user !== null && userGroupHistories !== null">
                <b-table
                    striped
                    hover
                    responsive
                    :items="userGroupHistories"
                    :fields="fields"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    @sort-changed="onChangeTable"
                    class="table-bordered m-table small">
                    <template v-slot:cell(created_at)="data">
                        <span class="u-palt">{{ helper.dateForHuman(data.item.created_at, 'Asia/Tokyo') }}</span>
                        <span
                            class="small font-weight-bold u-palt"
                            :class="helper.dayForHumanCSS(data.item.created_at, 'Asia/Tokyo')">
                            {{ helper.dayForHuman(data.item.created_at, 'Asia/Tokyo', { bracket: true }) }}
                        </span>
                        <span>{{ helper.timeForHuman(data.item.created_at, 'Asia/Tokyo') }}</span>
                    </template>

                    <template v-slot:cell(group_id)="data">
                        <a :href="`/admin/organizations/${data.item.group_id}`">
                            <span>{{ data.item.group.name }}</span>
                        </a>
                    </template>
                </b-table>

                <div class="d-flex flex-wrap justify-content-between align-items-center">
                    <b-pagination
                        v-model="meta.current_page"
                        :total-rows="meta.total"
                        :per-page="meta.per_page"
                        @change="onChange"
                        class="mb-0">
                    </b-pagination>
                    <div class="small">{{ dispPaginationDetail }}</div>
                </div>
            </div>
            <div
                v-else-if="inProgress"
                class="d-flex align-items-center justify-content-center p-5">
                <b-spinner variant="yokumiru-admin"/>
            </div>
        </div>
    </b-modal>
</template>

<script>
    import constants from '../../../constants'
    import YokumiruHelper from '../../../YokumiruHelper'

    export default {
        name: 'StopUserModal',

        data: function () {
            return {
                helper: YokumiruHelper,
                inProgress :false,
                modalShow: false,
                user: null,
                userGroupHistories: null,
                fields: [
                    {
                        key: 'id',
                        label: '#',
                        sortable: true,
                    },
                    {
                        key: 'created_at',
                        label: '履歴日時',
                        sortable: true,
                    },
                    {
                        key: 'group_id',
                        label: 'グループ名',
                        sortable: false,
                    },
                    {
                        key: 'history_type_human',
                        label: '分類',
                        sortable: false,
                    },
                ],
                sortBy: 'id',
                sortDesc: false,
                meta: {
                    current_page: 1,
                },
            }
        },

        computed: {
            /**
             * ページング詳細表示
             * @returns {string}
             */
            dispPaginationDetail: function () {
                if (this.meta.total < 1) {
                    return ''
                }
                return `全${this.meta.total}件中 ${this.meta.from}～${this.meta.to}件表示`
            },
        },

        created: function () {
            bus.$on('open-modal-user-group-histories', this.open)
        },

        beforeDestroy: function () {
            bus.$off('open-modal-user-group-histories')
        },

        methods: {
            /**
             * モーダルを表示
             *
             * @param {object} user
             */
            open: function (user) {
                this.user = user
                this.fetchUserGroupHistories()
                this.modalShow = true
            },

            /**
             * モーダルを閉じる
             */
            close: function () {
                this.modalShow = false
            },

            onChange: async function(page) {
                if (page) {
                    this.meta.current_page = page
                }
                await this.fetchUserGroupHistories()
            },

            onChangeTable: async function(sort) {
                if (sort) {
                    this.sortBy = sort.sortBy
                    this.sortDesc = sort.sortDesc
                }
                await this.fetchUserGroupHistories()
            },

            /**
             * QueryString生成
             *
             * @param {boolean} paginate
             * @return {string}
             */
            buildQuery: function (paginate = true) {
                let query = '?'
                
                if (paginate) {
                    query += `page=${this.meta.current_page}`
                }
                query += `&sort=${this.sortBy}`
                query += `&desc=${this.sortDesc}`

                return query
            },

            /**
             * グループ所属履歴取得
             */
            fetchUserGroupHistories: async function() {
                if (this.inProgress) return
                this.inProgress = true

                this.userGroupHistories = null

                await axios.get(`${constants.admin.users.endpoint.base}/${this.user.id}/group_user_histories${this.buildQuery()}`)
                    .then(({data}) => {
                        this.userGroupHistories = data.data
                        this.meta = data.meta
                    })

                this.inProgress = false
            },

            isCyclePlan: function (plan) {
                return constants.planTypes.cycle.includes(plan.key)
            },
        },
    }
</script>
